
import './App.css';
// import { VideoPlayer } from './Pages/VideoPlayer';


import AllRoutes from './Routes/AllRoutes';
function App() {
  return (
    <div >
      <AllRoutes />
    
   {/* <VideoPlayer /> */}
    </div>
  );
}

export default App;
